import type { ApplicationUser } from 'types/company/applicationUser';
import { udidKey } from 'utils/auth/clerkUserId';

export function resolveSuperAdminUser(
  superAdmin: ApplicationUser | string | null | undefined,
  applicationUsers: ApplicationUser[],
): ApplicationUser | null {
  if (superAdmin == null) return null;
  if (typeof superAdmin === 'object') {
    return superAdmin;
  }
  const id = superAdmin.trim();
  if (!id) return null;
  // OwnerCompany.SuperAdmin שומר את AspNetUsers.Id (כך האונבורדינג והמיגרציה כותבים),
  // ואילו השיוכים במערכת עובדים ב-Udid — אצלנו שני המזהים שונים אצל כל משתמש.
  // השוואה ל-Udid בלבד לא מצאה אף פעם את הסופר אדמין (מסך "אודות" + התראת הכותרת).
  const wanted = udidKey(id).toLowerCase();
  return (
    applicationUsers.find(
      (u) => udidKey(u.Udid).toLowerCase() === wanted || String(u.Id ?? '').trim().toLowerCase() === wanted,
    ) ?? null
  );
}
